/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /**
     * Renders a list of address predictions as returned from google
     *
     * <google-address-autocomplete input="address.searchText"></google-address-autocomplete>
     */
    app.directive('googleAddressAutocomplete', [function () {

        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                input: '=',
                predictionSelectedCallback: '=',
                predictionDisplayLimit: '@'
            },
            controller: [
                '$scope',
                'GoogleApiService',
                'CmsContentService',
                function (
                    $scope,
                    GoogleApiService,
                    CmsContentService
                ) {
                    var noLocationFound = {};
                    CmsContentService.getMarketPlaceText('base:google_autocomplete_no_places_error').then(function (text) {
                        noLocationFound.description = text;
                    });
                    $scope.predictionSelected = false;
                    $scope.$watch('input', function () {
                        $scope.addressPredictions = [];
                        if ($scope.predictionSelected) {
                            $scope.predictionSelected = false;
                            if ($scope.predictionSelectedCallback) {
                                $scope.predictionSelectedCallback();
                            }
                        } else {
                            if ($scope.input.length) {
                                GoogleApiService.addressAutocomplete($scope.input).then(function success(predictions) {
                                    $scope.addressPredictions = predictions;
                                }, function error() {
                                    $scope.addressPredictions = [noLocationFound];
                                });
                            }
                        }
                    });

                    $scope.setInput = function (prediction) {
                        if (prediction.description === noLocationFound.description) {
                            $scope.input = '';
                        } else {
                            $scope.input = prediction.description;
                            $scope.predictionSelected = true;
                        }
                    };

                }],
            template: require('@app/shared/integrations/googleApi/autocomplete/googleAutocompleteView.html'),
        };
    }]);
})(angular);